import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { industries } from "../mock";
import Reveal from "./Reveal";

export default function Industries() {
  const [active, setActive] = useState(0);

  return (
    <section id="industries" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="overline text-sm mb-1">Industries we serve</p>
          <h2 className="section-title text-3xl md:text-5xl mb-4">Built for every business</h2>
          <p className="text-slate-600">
            We take pride in being an innovative partner across diverse sectors &mdash; shaping a
            sustainable future for Hospitality, Retail and the Beverage industry.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div className="relative rounded-3xl overflow-hidden h-[340px] md:h-[460px]">
              {industries.map((ind, i) => (
                <img
                  key={ind.title}
                  src={ind.image}
                  alt={ind.title}
                  className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${
                    active === i ? "opacity-100" : "opacity-0"
                  }`}
                />
              ))}
              <div className="absolute inset-0 bg-gradient-to-t from-[rgba(10,42,67,0.75)] to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="font-head font-bold text-white text-2xl md:text-3xl">{industries[active].title}</h3>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex flex-col gap-3">
              {industries.map((ind, i) => (
                <button
                  key={ind.title}
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  className={`text-left p-5 rounded-2xl border transition-all ${
                    active === i
                      ? "border-[color:var(--brand-blue)] bg-[color:var(--brand-ice)] shadow-md"
                      : "border-slate-200 bg-white hover:border-slate-300"
                  }`}
                >
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="font-head font-semibold text-lg" style={{ color: "var(--brand-navy)" }}>{ind.title}</h4>
                    <ArrowRight size={18} className={active === i ? "text-[color:var(--brand-blue)]" : "text-slate-400"} />
                  </div>
                  <p className="text-sm text-slate-500 leading-relaxed">{ind.desc}</p>
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
